import { fileObject } from "@boark/shared/types/file-object";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { useLocale } from "../stores/locale";
import { formatDateTime } from "../utils/date";
import { formatSize } from "../utils/format-size";
import { deleteRequest } from "../utils/request";
import { Button } from "./button";
import { FileIcon } from "./file-icon";

const API_BASE_URL = process.env.API_BASE_URL || "/api";

type FileEntry = fileObject & {
  type: "file";
  size: number;
  lastModified: Date;
};

export function EmbeddedFileList({
  files,
  path,
  onChanged,
  readOnly = false,
}: {
  files: FileEntry[];
  path: string;
  onChanged: () => void;
  readOnly?: boolean;
}) {
  const t = useLocale((state) => state.locale);

  if (files.length === 0) {
    return null;
  }

  return (
    <ul className="border-t border-gray-200 divide-y divide-gray-200">
      {files.map((file) => (
        <li
          key={file.name}
          className="flex items-center gap-3 px-3 py-2 text-sm text-gray-700"
        >
          <FileIcon object={file} />
          <span className="flex-1 truncate">{file.name}</span>
          <span className="text-gray-500 shrink-0">
            {formatSize(file.size)}
          </span>
          <span className="text-gray-500 shrink-0 hidden sm:inline">
            {formatDateTime(file.lastModified, false)}
          </span>
          <Button
            href={`${API_BASE_URL}/download?path=${encodeURIComponent(`${path}/${file.name}`)}`}
            size="sm"
            target="_blank"
          >
            <FontAwesomeIcon icon={faDownload} />
          </Button>
          {!readOnly && (
            <Button
              severity="secondary"
              size="sm"
              onClick={() => {
                (async () => {
                  await deleteRequest(
                    `${API_BASE_URL}/file?path=${encodeURIComponent(`${path}/${file.name}`)}`,
                  );
                  onChanged();
                })();
              }}
            >
              {t.action.delete}
            </Button>
          )}
        </li>
      ))}
    </ul>
  );
}
